export enum AttributeType {
  ShortText = "short_text",
  ListShortText = "list_short_text",
  LongText = "long_text",
  RichText = "rich_text",
  Json = "json",
  Date = "date",
  Datetime = "datetime",
  Integer = "integer",
  Float = "float",
  Boolean = "boolean",
  Enum = "enum",
  ProductCategory = "product_category",
  HsCode = "hs_code",
  Weight = "weight",
  Money = "money",
  Dimension = "dimension",
  Volume = "volume",
  Link = "link",
  Color = "color",
}
